module.exports = __webpack_public_path__ + "img/l2.0476d527.png";